import { Box, Stack, Typography } from '@mui/material';

function BreakdownBars({ items }) {
  return (
    <Stack spacing={0.75}>
      {items.map((item) => (
        <Box key={item.category}>
          <Stack direction="row" sx={{ justifyContent: 'space-between', mb: 0.25 }}>
            <Typography variant="caption" color="text.secondary">
              {item.category}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {item.value}%
            </Typography>
          </Stack>
          <Box sx={{ height: 6, borderRadius: 3, bgcolor: 'action.hover', overflow: 'hidden' }}>
            <Box
              sx={{
                height: '100%',
                width: `${Math.min(Math.max(Number(item.value) || 0, 0), 100)}%`,
                borderRadius: 3,
                bgcolor: 'primary.main',
              }}
            />
          </Box>
        </Box>
      ))}
    </Stack>
  );
}

export default BreakdownBars;
